import template from './print_bulk_cash.html';
import controller from './print_bulk_cash.controller';
import './print_bulk_cash.scss';

let PrintBulkCashComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default PrintBulkCashComponent;



// WEBPACK FOOTER //
// ./client/app/components/bulk_cash_management/print/print_bulk_cash.component.js